import type { ReactNode } from 'react';
import { SearchX, AlertTriangle } from 'lucide-react';

interface ErrorScreenProps {
  /** Swaps the icon and drops the "try again" affordance. */
  is404: boolean;
  title: string;
  message: string;
  /** Rendered below the message -- action buttons. */
  children: ReactNode;
}

/**
 * Shared presentation for the full-page error screens. Deliberately holds no
 * router or i18n state so it can back both the route error boundary and the
 * catch-all 404 route.
 */
export function ErrorScreen({ is404, title, message, children }: ErrorScreenProps) {
  const Icon = is404 ? SearchX : AlertTriangle;

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-8">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <Icon className="h-8 w-8 text-red-600" aria-hidden="true" />
        </div>

        <h1 className="mb-2 text-2xl font-bold text-gray-900">{title}</h1>
        <p className="mb-6 text-gray-600">{message}</p>

        <div className="flex flex-wrap justify-center gap-3">{children}</div>
      </div>
    </div>
  );
}
